/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Create_SourceInputs */

const en_statement_taxonomy_create_source = /** @type {(inputs: Statement_Taxonomy_Create_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from`)
};

const nl_statement_taxonomy_create_source = /** @type {(inputs: Statement_Taxonomy_Create_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginnen vanuit`)
};

/**
* | output |
* | --- |
* | "Start from" |
*
* @param {Statement_Taxonomy_Create_SourceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_create_source = /** @type {((inputs?: Statement_Taxonomy_Create_SourceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Create_SourceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_create_source(inputs)
	return en_statement_taxonomy_create_source(inputs)
});